import { DefaultPosition } from '../PanelTemplatesTheme/constants';

import { Panel } from 'models/Panel/Panel';
import { WidgetDataTableCrossTab } from './WidgetDataTableCrossTab';

export const PanelDataTableCrossTab: Panel = {
    id: 'data-table-cross-tab',
    name: 'Cross Tab Table',
    description: '',
    tags: ['Standard', 'Data Table', 'landscape', 'portrait'],
    widget: {
        id: '1',
        position: {
            width: '1920px',
            height: '1080px',
            top: '0',
            left: '0',
        },
        classes: 'template_data_table_cross_tab',
        children: [
            {
                ...WidgetDataTableCrossTab,
                position: DefaultPosition,
                options: {
                    ...WidgetDataTableCrossTab.options,
                    smartSize: {
                        enabled: true,
                        mode: 'responsive',
                        size: 'xl',
                    },
                },
            },
        ],
    },
};
